import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {RestApiService} from '../../../../core/services/http/rest-api.service';
import {Observable} from 'rxjs';
import {ApiRoutesEnum} from '../../../../core/services/http/api-routes.enum';
import {ApiSettingsListResponse} from './api-settings-list-response';
import {ApiSettingsEditRequest} from './api-settings-edit-request';
import {ApiSettingsListRequest} from './api-settings-list-request';

@Injectable()
export class SettingsRestApiService {

  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _restApiService: RestApiService,
  ) {
  }

  public requestSettingsList(queryParams: ApiSettingsListRequest): Observable<ApiSettingsListResponse> {
    const url: string = [
      this._restApiService.authApiUrl,
      ApiRoutesEnum.SETTINGS,
    ].join('/');
    const params: HttpParams = this._restApiService.createHttpParams(queryParams);

    return this._httpClient.get<ApiSettingsListResponse>(url, {params: params});
  }

  public requestUpdate(settingsId: string, data: ApiSettingsEditRequest): Observable<void> {
    const url: string = [
      this._restApiService.authApiUrl,
      ApiRoutesEnum.SETTINGS,
      settingsId,
    ].join('/');

    return this._httpClient.put<void>(url, data);
  }
}
